import React from "react";
import PageHeader from "../../components/PageHeader";
const About = () =>{
    return(
        <>
            <PageHeader title="ABOUT US" description="We are an emerging software development team helping businesses, start-ups, and nonprofits envision and build brands, websites, tools, and apps their customers will love." />
            <div className="container-full-width border-top py-5">
                <div className="row">
                    <div className="col-md-8">
                    <div><h3>Who We Are.</h3>
                    
                    <p>At Top Tech Giants, we are an emerging team specializing in web and mobile application development. We support federal agencies, non-profits, and associations by helping them streamline and modernize their digital platforms. Our mission is to enhance the speed, simplicity, and user-friendliness of their websites and applications.

                    With a growing portfolio and deep commitment to quality, we focus on delivering tailored, effective solutions—on time and within budget. We prioritize long-term relationships and take the time to truly understand our clients’ needs and preferences. By aligning closely with their goals, we consistently aim to exceed expectations and foster lasting satisfaction.
                    </p>
                    <br /> <br />                                       
                    <h3>Why We Are Different.</h3>
                    <p>Every day, we dedicate ourselves to attaining the utmost quality and cost-effective solutions. Through rigorous testing and effective communication, we ensure the delivery of functional software. Our comprehensive process not only saves our clients time and money but also enhances workflows, business intelligence, and brand awareness. Employing software development and web best practices, we model our web designs and applications on industry standards. The outcomes we provide include:</p><ul><li>Meticulousness is our focus – we conduct thorough testing, fine-tune, and ensure your website operates at peak performance levels.</li>
                    <li>Embracing innovation - we allocate a portion of our time to explore emerging technologies and their potential benefits for our clients.</li>
                    <li>We attentively heed our clients, comprehend their needs, and provide precisely what they desire.</li></ul></div>

                    </div>
                </div>
             
            </div>
        </>

    );
}

export default About;
